import script from "./illustration.vue?vue&type=script&setup=true&lang=js"
export * from "./illustration.vue?vue&type=script&setup=true&lang=js"

import "./illustration.vue?vue&type=style&index=0&id=6146279a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6146279a"]])

export default __exports__